import {Button, DatePicker, Form, Radio, Select, Table, Tooltip} from 'antd'
import React, {useEffect, useState} from 'react'
import {
    KeyFilterClause,
    RawReportKeyColumnDescription,
    RawReportRequestParameters,
    RawReportValueColumnDescription
} from 'src/api/api'
import reportApi from '../reports/ReportApi'
import {calculateColumnsWidth} from './dynamicColumnsHelper'
import DownloadOutlined from '@ant-design/icons/lib/icons/DownloadOutlined';
import moment from 'dayjs';
import {DateOption} from '../../../util/Util';
import './style.css'
import {headerDescription} from '../reports/ReportUtil';

const { RangePicker } = DatePicker;

const dateFormat = 'YYYY-MM-DDTHH:00:00'

// const formInfoItems: FormDataType[] = [
//     FormDataType.Publishers
// ]

const FormItem = Form.Item
const Option = Select.Option
const RawKeyColumns = RawReportKeyColumnDescription.ColumnEnum
const RawValueColumns = RawReportValueColumnDescription.ColumnEnum

const defaultColumns = [RawKeyColumns.RequestId, RawKeyColumns.PublisherId, RawKeyColumns.DspId]
// src/global.d.ts



export const RawReport: React.FC = () => {

    const [loading, setLoading] = useState(false)
    // const [error, setError] = useState(undefined)
    const [form] = Form.useForm()

    const [blobCsv, setBlobCsv] = useState<any>()
    const [header, setHeader] = useState<string[]>()
    const [data, setData] = useState<string[][]>()
    const [datePeriod, setDatePeriod] = useState<any>(DateOption.Month)
    const [dates, setDates] = useState<[moment.Dayjs, moment.Dayjs]>()

    const [groupReport, setGroupReport] = useState(false)

    const getGroupKeyColumns = (cols: string[], formValues: any) => {

        const res: RawReportKeyColumnDescription[] = []

        let dateCol: RawReportKeyColumnDescription
        dateCol = {
            column: RawKeyColumns.Timestamp,
            where: {
                type: KeyFilterClause.TypeEnum.Between,
                value: formValues.dates.map(d => d.format(dateFormat))
            }
        }
        if (cols?.findIndex(col => col === RawKeyColumns.Timestamp.toString()) === -1) {
            dateCol.onlyFilter = true
        }
        res.push(dateCol)

        if (cols.findIndex(col => col === RawKeyColumns.PublisherIdGroup.toString()) !== -1) {
            res.push({
                column: RawKeyColumns.PublisherIdGroup,
            })
        }

        if (cols.findIndex(col => col === RawKeyColumns.ImpIdGroup.toString()) !== -1) {
            res.push({
                column: RawKeyColumns.ImpIdGroup,
            })
        }

        if (cols.findIndex(col => col === RawKeyColumns.RequestIdGroup.toString()) !== -1) {
            res.push({
                column: RawKeyColumns.RequestIdGroup,
            })
        }

        if (cols.findIndex(col => col === RawKeyColumns.TimestampGroup.toString()) !== -1) {
            res.push({
                column: RawKeyColumns.TimestampGroup,
            })
        }

        return res
    }

    const getKeyColumns = (cols: string[], formValues: any) => {

        const res: RawReportKeyColumnDescription[] = []

        let dateCol: RawReportKeyColumnDescription
        dateCol = {
            column: RawKeyColumns.Timestamp,
            where: {
                type: KeyFilterClause.TypeEnum.Between,
                value: formValues.dates.map(d => d.format(dateFormat))
            }
        }
        if (cols?.findIndex(col => col === RawKeyColumns.Timestamp.toString()) === -1) {
            dateCol.onlyFilter = true
        }
        res.push(dateCol)

        // if (cols?.findIndex(col => col === RawKeyColumns.Publisher.toString()) !== -1) {
        //     res.push({
        //         column: RawKeyColumns.Publisher,
        //     })
        //     if (formValues.publishers && formValues.publishers.length > 0) {
        //         if (formValues.publishers.length > 1) {

        //             res.push({
        //                 column: RawKeyColumns.PublisherId,
        //                 where: {
        //                     type: KeyFilterClause.TypeEnum.In,
        //                     value: formValues.publishers
        //                 },
        //                 onlyFilter: true
        //             })
        //         } else if (formValues.publishers.length === 1) {
        //             res.push({
        //                 column: RawKeyColumns.PublisherId,
        //                 where: {
        //                     type: KeyFilterClause.TypeEnum.Equals,
        //                     value: formValues.publishers
        //                 },
        //                 onlyFilter: true
        //             })
        //         }
        //     }
        // }

        if (cols.findIndex(col => col === RawKeyColumns.Audio.toString()) !== -1) {
            res.push({
                column: RawKeyColumns.Audio,
            })
        }

        if (cols.findIndex(col => col === RawKeyColumns.Banner.toString()) !== -1) {
            res.push({
                column: RawKeyColumns.Banner,
            })
        }

        if (cols.findIndex(col => col === RawKeyColumns.Video.toString()) !== -1) {
            res.push({
                column: RawKeyColumns.Video,
            })
        }

        if (cols.findIndex(col => col === RawKeyColumns.BidId.toString()) !== -1) {
            res.push({
                column: RawKeyColumns.BidId,
            })
        }

        if (cols.findIndex(col => col === RawKeyColumns.DspBid.toString()) !== -1) {
            res.push({
                column: RawKeyColumns.DspBid,
            })
        }

        if (cols.findIndex(col => col === RawKeyColumns.DspBidPrice.toString()) !== -1) {
            res.push({
                column: RawKeyColumns.DspBidPrice,
            })
        }

        if (cols.findIndex(col => col === RawKeyColumns.DspId.toString()) !== -1) {
            res.push({
                column: RawKeyColumns.DspId,
            })
        }

        if (cols.findIndex(col => col === RawKeyColumns.DspImpr.toString()) !== -1) {
            res.push({
                column: RawKeyColumns.DspImpr
                ,
            })
        }

        if (cols.findIndex(col => col === RawKeyColumns.DspImprPrice.toString()) !== -1) {
            res.push({
                column: RawKeyColumns.DspImprPrice,
            })
        }

        if (cols.findIndex(col => col === RawKeyColumns.DspReq.toString()) !== -1) {
            res.push({
                column: RawKeyColumns.DspReq,
            })
        }

        if (cols.findIndex(col => col === RawKeyColumns.DspRequest.toString()) !== -1) {
            res.push({
                column: RawKeyColumns.DspRequest,
            })
        }

        if (cols.findIndex(col => col === RawKeyColumns.DspResponse.toString()) !== -1) {
            res.push({
                column: RawKeyColumns.DspResponse,
            })
        }

        if (cols.findIndex(col => col === RawKeyColumns.DspWin.toString()) !== -1) {
            res.push({
                column: RawKeyColumns.DspWin,
            })
        }

        if (cols.findIndex(col => col === RawKeyColumns.DspWinPrice.toString()) !== -1) {
            res.push({
                column: RawKeyColumns.DspWinPrice,
            })
        }

        if (cols.findIndex(col => col === RawKeyColumns.ImpId.toString()) !== -1) {
            res.push({
                column: RawKeyColumns.ImpId,
            })
        }

        if (cols.findIndex(col => col === RawKeyColumns.Ip.toString()) !== -1) {
            res.push({
                column: RawKeyColumns.Ip,
            })
        }

        if (cols.findIndex(col => col === RawKeyColumns.PrebidBid.toString()) !== -1) {
            res.push({
                column: RawKeyColumns.PrebidBid,
            })
        }

        if (cols.findIndex(col => col === RawKeyColumns.PrebidBidFloor.toString()) !== -1) {
            res.push({
                column: RawKeyColumns.PrebidBidFloor,
            })
        }

        if (cols.findIndex(col => col === RawKeyColumns.PrebidBidPrice.toString()) !== -1) {
            res.push({
                column: RawKeyColumns.PrebidBidPrice,
            })
        }

        if (cols.findIndex(col => col === RawKeyColumns.PrebidImpr.toString()) !== -1) {
            res.push({
                column: RawKeyColumns.PrebidImpr,
            })
        }

        if (cols.findIndex(col => col === RawKeyColumns.PrebidReq.toString()) !== -1) {
            res.push({
                column: RawKeyColumns.PrebidReq,
            })
        }

        if (cols.findIndex(col => col === RawKeyColumns.PrebidRequest.toString()) !== -1) {
            res.push({
                column: RawKeyColumns.PrebidRequest,
            })
        }

        if (cols.findIndex(col => col === RawKeyColumns.PrebidResponse.toString()) !== -1) {
            res.push({
                column: RawKeyColumns.PrebidResponse,
            })
        }

        if (cols.findIndex(col => col === RawKeyColumns.PrebidWin.toString()) !== -1) {
            res.push({
                column: RawKeyColumns.PrebidWin,
            })
        }

        if (cols.findIndex(col => col === RawKeyColumns.PublisherId.toString()) !== -1) {
            res.push({
                column: RawKeyColumns.PublisherId,
            })
        }

        if (cols.findIndex(col => col === RawKeyColumns.RequestId.toString()) !== -1) {
            res.push({
                column: RawKeyColumns.RequestId,
            })
        }

        if (cols.findIndex(col => col === RawKeyColumns.UserAgent.toString()) !== -1) {
            res.push({
                column: RawKeyColumns.UserAgent,
            })
        }

        return res
    }

    const getValueColumns = (cols: string[], formValues: any) => {

        const res: RawReportValueColumnDescription[] = []
        if (!cols) {
            return res
        }

        if (cols.findIndex(col => col === RawValueColumns.Audio.toString()) !== -1) {
            res.push({
                column: RawValueColumns.Audio,
            })
        }

        if (cols.findIndex(col => col === RawValueColumns.Banner.toString()) !== -1) {
            res.push({
                column: RawValueColumns.Banner,
            })
        }

        if (cols.findIndex(col => col === RawValueColumns.Video.toString()) !== -1) {
            res.push({
                column: RawValueColumns.Video,
            })
        }

        if (cols.findIndex(col => col === RawValueColumns.BidId.toString()) !== -1) {
            res.push({
                column: RawValueColumns.BidId,
            })
        }

        if (cols.findIndex(col => col === RawValueColumns.DspsBids.toString()) !== -1) {
            res.push({
                column: RawValueColumns.DspsBids,
            })
        }

        if (cols.findIndex(col => col === RawValueColumns.PrebidBidFloor.toString()) !== -1) {
            res.push({
                column: RawValueColumns.PrebidBidFloor,
            })
        }

        if (cols.findIndex(col => col === RawValueColumns.PrebidBidPrice.toString()) !== -1) {
            res.push({
                column: RawValueColumns.PrebidBidPrice,
            })
        }

        if (cols.findIndex(col => col === RawValueColumns.PrebidRequest.toString()) !== -1) {
            res.push({
                column: RawValueColumns.PrebidRequest,
            })
        }

        if (cols.findIndex(col => col === RawValueColumns.PrebidResponse.toString()) !== -1) {
            res.push({
                column: RawValueColumns.PrebidResponse,
            })
        }

        return res
    }

    const csvToArray = (text) => {
        const reValid = /^\s*(?:'[^'\\]*(?:\\[\S\s][^'\\]*)*'|"[^"\\]*(?:\\[\S\s][^"\\]*)*"|[^,'"\s\\]*(?:\s+[^,'"\s\\]+)*)\s*(?:,\s*(?:'[^'\\]*(?:\\[\S\s][^'\\]*)*'|"[^"\\]*(?:\\[\S\s][^"\\]*)*"|[^,'"\s\\]*(?:\s+[^,'"\s\\]+)*)\s*)*$/
        const reValue = /(?!\s*$)\s*(?:'([^'\\]*(?:\\[\S\s][^'\\]*)*)'|"([^"\\]*(?:\\[\S\s][^"\\]*)*)"|([^,'"\s\\]*(?:\s+[^,'"\s\\]+)*))\s*(?:,|$)/g

        if (!reValid.test(text)) {
            return undefined
        }
        const a: string[] = []
        text.replace(reValue,
            (m0: any, m1: any, m2: any, m3: any) => {
                if (m1 !== undefined) {
                    a.push(m1.replace(/\\'/g, '\''))
                } else if (m2 !== undefined) {
                    a.push(m2.replace(/\\"/g, '\''))
                } else if (m3 !== undefined) {
                    a.push(m3)
                }
            })
        if (/,\s*$/.test(text)) {
            a.push('')
        }
        return a
    }

    const handleSubmit = async () => {
        setLoading(true)
        setBlobCsv(undefined)
        setData(undefined)
        const values = await form.validateFields()

        const cols = values.columns as string[]
        const groupCols = values.publishers as string[]
        const keyCols = getKeyColumns(cols, values)
        let groupKeyCols = [] as RawReportKeyColumnDescription[]
        let valueCols = [] as RawReportValueColumnDescription[]

        if (groupCols?.includes(RawKeyColumns.PublisherIdGroup.toString()) || groupCols?.includes(RawKeyColumns.ImpIdGroup.toString()) || groupCols?.includes(RawKeyColumns.RequestIdGroup.toString()) || groupCols?.includes(RawKeyColumns.TimestampGroup.toString())) {
            groupKeyCols = getGroupKeyColumns(groupCols, values)
            valueCols = getValueColumns(cols, values)
        }

        const uuid = await reportApi.createRaw(
            { keyColumns: groupKeyCols.length > 0 ? groupKeyCols : keyCols, valueColumns: valueCols, reportType: RawReportRequestParameters.ReportTypeEnum.Raw })
            .then(resp => resp.data)
        if (!uuid) {
            return
        }
        let interval = setInterval(async () => {

            try {
                const response = await reportApi.get(uuid ?? '')
                clearInterval(interval)
                const blob = await response.blob()
                const text = await blob.text()
                if (text.length < 1) {
                    setLoading(false)
                    return
                }
                const rows = text.split('\n')
                if (rows.length < 2) {
                    setLoading(false)
                    return
                }
                const headerLine = csvToArray(rows[0])
                setHeader(headerLine)
                const index = headerLine?.findIndex(h => h === 'Dsps bids')
                rows.shift()
                rows.pop()
                const main = rows.map(row => {
                    const mainLine = csvToArray(row)
                    if (index && index !== -1 && mainLine) {
                        mainLine[index] = mainLine[index].replace('[', '').replace(']', '').split(',').map(line => line.split(';').join(' ')).join('\n\n')
                    }
                    return mainLine ?? []
                })
                setData(main)
                setLoading(false)
                setBlobCsv(blob as any)

            } catch (response) {
                if (typeof response === 'object') {
                    if (response.status !== 425) {
                        setLoading(false)
                        clearInterval(interval)
                    }
                }
            }
        }, 500)
    }

    // const [info, setInfo] = useState({
    //     publishers: []
    // })

    // const onRejected = err => {
    //     setError(err.error)
    // }

    // const loadData = async () => {
    //     try {
    //         let formInfo = await formDataLoader(...formInfoItems)
    //         // console.log(formInfo)
    //         // setInfo(formInfo as any)
    //     } catch (e) {
    //         onRejected(e)
    //     }
    // }

    useEffect(() => {
        // loadData()
        form.setFieldsValue({ columns: defaultColumns })
    }, [])

    const handleGroubBy = () => {
        const groupCols = form.getFieldValue('publishers') as string[]
        if (groupCols?.includes(RawKeyColumns.PublisherIdGroup.toString()) || groupCols?.includes(RawKeyColumns.ImpIdGroup.toString())) {
            setGroupReport(true)
            form.setFieldsValue({ columns: [] })
        } else {
            setGroupReport(false)
        }
    }

    const headerFunc = (headerToProcess?: any[]) => {
        return headerToProcess?.map(h => ({
            title: <Tooltip title={headerDescription.find(hd => hd.h === h)?.d}>{h}</Tooltip>,
            dataIndex: h.toLowerCase(),
            key: h.toLowerCase(),
        }))
    }

    const sourceFunc = (dataToProcess?: any[], headerToProcess?: any[]) => {
        return dataToProcess?.map(row => headerToProcess?.reduce((o, key, index) => ({ ...o, [key?.toLowerCase() ?? '']: row[index], key: index }), {}) ?? {})
    }

    const download = () => {
        // if (navigator?.msSaveBlob) { // IE 10+
        //     navigator?.msSaveBlob(blobCsv, 'report.csv');
        // } else {
            var link = document.createElement('a');
            if (link.download !== undefined) { // feature detection
                // Browsers that support HTML5 download attribute
                var url = URL.createObjectURL(blobCsv);
                link.setAttribute('href', url);
                link.setAttribute('download', 'report.csv');
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            // }
        }
    }

    const handleDatePeriod = (e) => {
        setDatePeriod(e.target.value)
        setDates([moment(moment().subtract(1, e.target.value), dateFormat), moment(moment(), dateFormat)])
    }

    const handleDates = (e) => {
        setDatePeriod(undefined)
        setDates(e)
    }

    useEffect(() => {
        form.setFieldsValue({dates: dates})
    }, [dates])

    return (
        <div>
            {loading}
            {/*{error && <div><Alert message={error} type="error" /><br /></div>}*/}
            <Form
                style={{
                    maxWidth: '1000px'
                }}
                onFinish={handleSubmit}
                form={form}
                labelCol={{ span: 3 }}
                wrapperCol={{ span: 21 }}
            >
                <FormItem
                    label="Dates"
                    name="dates"
                    rules={[
                        {
                            required: true,
                            message: 'Please choose dates'
                        }
                    ]}
                >
                    <RangePicker value={dates} format="YYYY-MM-DD HH:00" onChange={handleDates} showTime={{format: 'YYYY-MM-DD HH:00'}}/>
                    <Radio.Group id={'radioButtonsWithoutLines'} value={datePeriod} onChange={handleDatePeriod} size={'middle'} style={{margin: '0px 0px 0px 10px'}}>
                        {Object.keys(DateOption).map(option =>
                            <Radio.Button style={{border: '0px'}} key={option} value={option}>{option}</Radio.Button>)}
                    </Radio.Group>
                </FormItem>

                <FormItem
                    name="publishers"
                    label="Group by"
                    tooltip="Select group by"
                >
                    <Select
                        mode="multiple"
                        placeholder="Select publishers"
                        onChange={handleGroubBy}
                        listHeight={400}
                        allowClear
                    >
                        {Object.values([RawKeyColumns.PublisherIdGroup, RawKeyColumns.ImpIdGroup, RawKeyColumns.RequestIdGroup, RawKeyColumns.TimestampGroup])
                            .map(key => (<Option key={key} value={key} >{key.toString().replace('Group', '')}</Option>))}
                    </Select>
                </FormItem>

                <FormItem
                    name="columns"
                    label="Columns"
                    tooltip="Select columns to generate report with"
                    initialValue={defaultColumns}
                >
                    <Select
                        mode="multiple"
                        placeholder="Select columns"
                        listHeight={600}
                    >
                        {
                            groupReport ?
                                Object.keys(RawValueColumns)
                                    .map(key => (<Option key={key} value={key} >{key}</Option>))
                                :
                                Object.keys(RawKeyColumns)
                                    .filter(key => key !== RawKeyColumns.PublisherIdGroup.toString() && key !== RawKeyColumns.ImpIdGroup.toString()  && key !== RawKeyColumns.RequestIdGroup.toString() && key !== RawKeyColumns.TimestampGroup.toString())
                                    .map(key => (<Option key={key} value={key} >{key}</Option>))
                        }
                    </Select>
                </FormItem>

                <FormItem
                    wrapperCol={{
                        offset: 3, span: 21
                    }}>
                    <Button type="primary" htmlType="submit" loading={loading}>Apply</Button>
                </FormItem>
            </Form>

            {blobCsv && <Table
                style={{ 'whiteSpace': 'pre-wrap' }}
                scroll={{ x: calculateColumnsWidth(headerFunc(header) ?? [], sourceFunc(data, header) ?? [], 2000).tableWidth, y: 700 }}
                columns={calculateColumnsWidth(headerFunc(header) ?? [], sourceFunc(data, header) ?? [], 2000).columns}
                dataSource={calculateColumnsWidth(headerFunc(header) ?? [], sourceFunc(data, header) ?? [], 2000).source}
                footer={(data?.length ?? -1) > 0 ? (() => <Button onClick={download} icon={<DownloadOutlined />}>Download</Button>) : undefined}
            />}
        </div>
    )
}
